<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("CREATE") }}</h1>
      <b-button
        size="sm"
        variant="danger"
        class="button-danger-style ml-2 float-right mb-2"
        @click="goBack"
      >
        <font-awesome-icon icon="arrow-left" /> {{ "Retour" }}
      </b-button>
    </div>
    <div class="content">
      <b-card>
        <form @submit.prevent="handleSubmit">
          <b-form-group :label="$t('Date d’engagement') + '*'">
            <b-form-input
              type="date"
              v-model="formData.dateEngagement"
              :state="validateState('dateEngagement')"
              required
            ></b-form-input>
            <error-handle
              :list="v$.formData.dateEngagement.$errors"
              id="dateEngagement-feedback"
            ></error-handle>
          </b-form-group>
        
          <b-form-group :label="$t('Date prévue de réalisation') + '*'">
            <b-form-input
              type="date"
              v-model="formData.datePrevuRealisation"
              :state="validateState('datePrevuRealisation')"
              required
            ></b-form-input>
            <error-handle
              :list="v$.formData.datePrevuRealisation.$errors"
              id="datePrevuRealisation-feedback"
            ></error-handle>
          </b-form-group>
          <b-form-group 
            v-if="isSuperAdmin" 
            :label="$t('ENTREPRISES') + '*'"
          >
            <b-form-select
              v-model="selectedEntreprise"
              :options="entrepriseOptions"
              @change="onEntrepriseChange"
              :disabled="getentrepriseLoading"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>
                  {{ $t("Sélectionner une entreprise") }}
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group :label="$t('FACTURE') + '*'">
            <b-form-select
              v-model="formData.factureId"
              :options="factureOptions"
              :state="validateState('factureId')"
              :disabled="getdevisLoading"
              @change="onFactureChange"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>
                  {{ $t("Sélectionner facture") }}
                </b-form-select-option>
              </template>
            </b-form-select>
            <error-handle
              :list="v$.formData.factureId.$errors"
              id="factureId-feedback"
            ></error-handle>
        
            
            <!-- Affichage des informations de la facture sélectionnée -->
          
          </b-form-group>

          <!-- Conditional Forms based on facture groups -->
          <div v-if="selectedFactureGroups.length > 0" class="conditional-forms mt-4">
            <!-- Use tabs if multiple forms, otherwise display directly -->
            <b-tabs v-if="selectedFactureGroups.length > 1" v-model="activeTab" content-class="mt-3">
              <b-tab
                v-for="(group, index) in selectedFactureGroups"
                :key="`tab-${group.id}-${index}`"
                :title="getGroupLabel(group.type_group)"
                :active="index === 0"
              >
                <div class="form-group-section">
                  <!-- BAR-EN-101: Isolation de combles ou de toiture -->
                  <div v-if="group.type_group === 'BAR-EN-101'">
                    <b-form-group>
                      <template #label>
                        {{ $t('Nécessite_pare-vapeur') }}
                      </template>
                      <b-form-checkbox
                        v-model="groupFormData[group.id].necessite_pare_vapeur"
                        :value="1"
                        :unchecked-value="0"
                      >
                        {{ $t("Nécessite_pare-vapeur") }}
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group :label="$t('type_isolation') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_pose"
                        :options="typePoseOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_isolant"
                        :options="typeIsolantOptions"
                        @change="updateNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].norme"
                        :options="getNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('surface_isolant') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_isolant"
                        :placeholder="$t('surface_isolant')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('resistance_thermique') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].resistance_thermique"
                        :placeholder="$t('resistance_thermique')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('epaisseur') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].epaisseur"
                        :placeholder="$t('epaisseur')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-EN-102: Isolation des murs -->
                  <div v-if="group.type_group === 'BAR-EN-102'">
                    <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_isolant"
                        :options="typeIsolantOptions"
                        @change="updateNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].norme"
                        :options="getNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('surface_isolant') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].Surface_isolant"
                        :placeholder="$t('surface_isolant')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('resistance_thermique') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].resistance_thermique"
                        :placeholder="$t('resistance_thermique')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('epaisseur') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].epaisseur"
                        :placeholder="$t('epaisseur')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-EN-103: Isolation d'un plancher -->
                  <div v-if="group.type_group === 'BAR-EN-103'">
                    <b-form-group>
                      <template #label>
                        {{ $t("Protéger les matériaux d'isolation contre l'humidité par") }}
                      </template>
                      <b-form-radio-group
                        v-model="groupFormData[group.id].protection_type"
                        :options="protectionOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_isolant"
                        :options="typeIsolantOptions"
                        @change="updateNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].norme"
                        :options="getNormeOptions(group.id)"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('surface_isolant') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].Surface_isolant"
                        :placeholder="$t('surface_isolant')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('resistance_thermique') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].resistance_thermique"
                        :placeholder="$t('resistance_thermique')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('epaisseur') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].epaisseur"
                        :placeholder="$t('epaisseur')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-EN-104: Fenêtre ou porte-fenêtre complète avec vitrage isolant -->
                  <div v-if="group.type_group === 'BAR-EN-104'">
                    <b-form-group :label="$t('type_fenetre') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].type_fenetre"
                        :options="typeFenetreOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('nombre_fenetres') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].nombre_fenetres"
                        :placeholder="$t('nombre_fenetres')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('surface') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_totale"
                        :placeholder="$t('surface')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('coefficient_transmission') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].coefficient_transmission"
                        :placeholder="$t('coefficient_transmission')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('facteur_solaire') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].facteur_solaire"
                        :placeholder="$t('facteur_solaire')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-127: Ventilation mécanique simple flux hygroréglable -->
                  <div v-if="group.type_group === 'BAR-TH-127'">
                    <b-form-group>
                      <template #label>
                        {{ $t("Type d'installation") }}
                      </template>
                      <b-form-radio-group
                        v-model="groupFormData[group.id].type_installation"
                        :options="installationTypeOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <div v-if="groupFormData[group.id].type_installation === 'Installation collective'">
                      <b-form-group>
                        <template #label>
                          {{ $t("Type de ventilation") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].type_ventilation"
                          :options="ventilationTypeOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('nombre_logements') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].nombre_logements"
                          :placeholder="$t('nombre_logements')"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div v-if="groupFormData[group.id].type_installation === 'Installation individuelle'">
                      <b-form-group :label="$t('surface') + '*'">
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="groupFormData[group.id].surface_habitable"
                          :placeholder="$t('surface')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group :label="$t('classe') + '*'">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].classe_energetique"
                          :placeholder="$t('classe')"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <b-form-group :label="$t('Puissance') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        step="0.01"
                        v-model="groupFormData[group.id].puissance_electrique"
                        :placeholder="$t('Puissance')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-148: Chauffe-eau thermodynamique à accumulation -->
                  <div v-if="group.type_group === 'BAR-TH-148'">
                    <b-form-group :label="$t('type_installation')">
                      <b-form-select
                        v-model="groupFormData[group.id].type_installation"
                        :options="typeInstallationOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('COP') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].cop"
                        :placeholder="$t('COP')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-143: Système solaire -->
                  <div v-if="group.type_group === 'BAR-TH-143'">
                    <b-form-group>
                      <template #label>
                        {{ $t("Type de certification") }}
                      </template>
                      <b-form-radio-group
                        v-model="groupFormData[group.id].certification_type"
                        :options="certificationTypeOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <div v-if="groupFormData[group.id].certification_type === 'certification'">
                      <b-form-group>
                        <template #label>
                          {{ $t("Type de norme") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].norme_type"
                          :options="normeTypeOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('NOM_CERTIF') + '*'">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].certification"
                          :placeholder="$t('NOM_CERTIF')"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group v-if="groupFormData[group.id].norme_type === 'autres'" :label="$t('NORM') + '*'">
                        <b-form-input
                          type="text"
                          v-model="groupFormData[group.id].norme"
                          :placeholder="$t('NORM')"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <b-form-group :label="$t('FLUIDE') + '*'">
                      <b-form-input
                        type="text"
                        v-model="groupFormData[group.id].nature_fluide"
                        :placeholder="$t('FLUIDE')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Productivité')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].productivite"
                        :placeholder="$t('Productivité')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Surface_chauffe')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_chaufe"
                        :placeholder="$t('Surface_chauffe')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Surface_hors_tout')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_hors_tout"
                        :placeholder="$t('Surface_hors_tout')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Capacite_stockage')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].capacite_stockage"
                        :placeholder="$t('Capacite_stockage')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Classe_efficacite_energetique')">
                      <b-form-input
                        type="text"
                        v-model="groupFormData[group.id].classe_efficacite_energetique"
                        :placeholder="$t('Classe_efficacite_energetique')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-171: Pompe à chaleur de type air/eau -->
                  <div v-if="group.type_group === 'BAR-TH-171'">
                    <b-form-group :label="$t('Type_pompe') + '*'">
                      <b-form-select
                        v-model="groupFormData[group.id].denomination_temperature"
                        :options="pompeTypeOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('Coeffcient_performance') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        step="0.01"
                        v-model="groupFormData[group.id].coefficient_performance"
                        :placeholder="$t('Coeffcient_performance')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Efficacité_calculer_selon_réglément') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].efficacite"
                        :placeholder="$t('Efficacité')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Surface_chauffe') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_chauffee"
                        :placeholder="$t('Surface_chauffe')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Régulateur') + '*'">
                      <b-form-input
                        type="text"
                        v-model="groupFormData[group.id].regulateur_classe"
                        :placeholder="$t('Régulateur')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-129: Pompe à chaleur de type air/air -->
                  <div v-if="group.type_group === 'BAR-TH-129'">
                    <b-form-group :label="$t('Coeffcient_performance') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].coefficient_performance_saisonnier"
                        :placeholder="$t('Coeffcient_performance')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Puissance') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].puissance_nominale"
                        :placeholder="$t('Puissance')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('SURFACE') + '*'">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_chauffee"
                        :placeholder="$t('SURFACE')"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-137: Raccordement au réseau de chaleur -->
                  <div v-if="group.type_group === 'BAR-TH-137'">
                    <b-form-group>
                      <template #label>
                        {{ $t("Raccordé au réseau de chaleur") }}
                      </template>
                      <b-form-radio-group
                        v-model="groupFormData[group.id].deja_raccorder"
                        :options="raccordeOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <div v-if="groupFormData[group.id].deja_raccorder === true">
                      <b-form-group>
                        <template #label>
                          {{ $t("Raccordement") }}
                        </template>
                        <b-form-radio-group
                          v-model="groupFormData[group.id].existe_cetificat_economie"
                          :options="certificatOptions"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                    <b-form-group v-if="getLogementType() === 'Maison individuelle'" :label="$t('Surface habitable (m²)')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_habitable"
                        placeholder="Surface en m²"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group v-if="getLogementType() === 'Collectif' || getLogementType() === 'Appartement'" :label="$t('nbr_appartements')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].nbr_appartements"
                        :placeholder="$t('nbr_appartements')"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group :label="$t('Nom du réseau')">
                      <b-form-input
                        type="text"
                        v-model="groupFormData[group.id].nom_reseau"
                        placeholder="Nom du réseau"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>

                  <!-- BAR-TH-173: Système de régulation horaire -->
                  <div v-if="group.type_group === 'BAR-TH-173'">
                    <b-form-group :label="$t('Le type de système concerné')">
                      <b-form-select
                        v-model="groupFormData[group.id].concerne"
                        :options="concerneOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('Classe de régulation')">
                      <b-form-select
                        v-model="groupFormData[group.id].class"
                        :options="classOptions"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('L\'ancien système est de classe C')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].ancient_system_class_c"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('les pièces sont équipées d\'émetteurs')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].pieces_equipees_emetteur"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Dispositif central')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].comporte_appareil_central"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('dispose d\'une sonde de mesure')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].dispose_sonde_mesure"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('équipé d\'un dispositif de régulation')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].possede_dispositif_regulant"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('fonctionner localement au minimum')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].effectuer_local_minima"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Dérogation locale possible')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].deroger_localement_consignes"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Possibilité de fonctionnement en cas de perte de connexion')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].fonctionner_perte_connexion"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('le boîtier est équipé d\'émetteurs')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].logement_equipees_emetteur"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Planchers/Plafonds chauffants')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].planchers_plafonds_chauffants"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Remplacement du système existant')">
                      <b-form-radio-group
                        v-model="groupFormData[group.id].remlpacement"
                        :options="booleanOptions"
                      >
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group :label="$t('Surface habitable (m²)')">
                      <b-form-input
                        type="number"
                        min="0"
                        v-model="groupFormData[group.id].surface_chauffe"
                        placeholder="Surface en m²"
                      ></b-form-input>
                    </b-form-group>
                    
                    <b-form-group :label="$t('Données supplémentaires')">
                      <vue-editor
                        v-model="groupFormData[group.id].donnees_supplementaires"
                        :editor-toolbar="customToolbar"
                        class="mt-2"
                        :placeholder="$t('Ajouter des données supplémentaires')"
                      />
                    </b-form-group>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
            
            <!-- Single form without tabs -->
            <div v-else class="form-group-section">
              <div
                v-for="(group, index) in selectedFactureGroups"
                :key="index"
              >
                <div class="group-header mb-3">
                  <h4>{{ getGroupLabel(group.type_group) }}</h4>
                </div>
              
              <!-- BAR-EN-101: Isolation de combles ou de toiture -->
              <div v-if="group.type_group === 'BAR-EN-101'">
                <b-form-group>
                  <template #label>
                    {{ $t('Nécessite_pare-vapeur') }}
                  </template>
                  <b-form-checkbox
                    v-model="groupFormData[group.id].necessite_pare_vapeur"
                    :value="1"
                    :unchecked-value="0"
                  >
                    {{ $t("Nécessite_pare-vapeur") }}
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group :label="$t('type_isolation') + '*'">
                  <b-form-select
                    v-model="groupFormData[group.id].type_pose"
                    :options="typePoseOptions"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                  <b-form-select
                    v-model="groupFormData[group.id].type_isolant"
                    :options="typeIsolantOptions"
                    @change="updateNormeOptions(group.id)"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                  <b-form-select
                    v-model="groupFormData[group.id].norme"
                    :options="getNormeOptions(group.id)"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group :label="$t('surface_isolant') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].surface_isolant"
                    :placeholder="$t('surface_isolant')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('resistance_thermique') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].resistance_thermique"
                    :placeholder="$t('resistance_thermique')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('epaisseur') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].epaisseur"
                    :placeholder="$t('epaisseur')"
                  ></b-form-input>
                </b-form-group>
              </div>

              <!-- BAR-EN-102: Isolation des murs -->
              <div v-if="group.type_group === 'BAR-EN-102'">
                <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                  <b-form-select
                    v-model="groupFormData[group.id].type_isolant"
                    :options="typeIsolantOptions"
                    @change="updateNormeOptions(group.id)"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                  <b-form-select
                    v-model="groupFormData[group.id].norme"
                    :options="getNormeOptions(group.id)"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group :label="$t('surface_isolant') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].Surface_isolant"
                    :placeholder="$t('surface_isolant')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('resistance_thermique') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].resistance_thermique"
                    :placeholder="$t('resistance_thermique')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('epaisseur') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].epaisseur"
                    :placeholder="$t('epaisseur')"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>

              <!-- BAR-EN-103: Isolation d'un plancher -->
              <div v-if="group.type_group === 'BAR-EN-103'">
                <b-form-group>
                  <template #label>
                    {{ $t("Protéger les matériaux d'isolation contre l'humidité par") }}
                  </template>
                  <b-form-radio-group
                    v-model="groupFormData[group.id].protection_type"
                    :options="protectionOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('Types_isolants_thermiques') + '*'">
                  <b-form-select
                    v-model="groupFormData[group.id].type_isolant"
                    :options="typeIsolantOptions"
                    @change="updateNormeOptions(group.id)"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group v-if="groupFormData[group.id].type_isolant" :label="$t('NORM') + '*'">
                  <b-form-select
                    v-model="groupFormData[group.id].norme"
                    :options="getNormeOptions(group.id)"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group :label="$t('surface_isolant') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].Surface_isolant"
                    :placeholder="$t('surface_isolant')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('resistance_thermique') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].resistance_thermique"
                    :placeholder="$t('resistance_thermique')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('epaisseur') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].epaisseur"
                    :placeholder="$t('epaisseur')"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>

              <!-- BAR-EN-104: Fenêtre ou porte-fenêtre complète avec vitrage isolant -->
              <div v-if="group.type_group === 'BAR-EN-104'">
                <b-form-group :label="$t('type_fenetre') + '*'">
                  <b-form-select
                    v-model="groupFormData[group.id].type_fenetre"
                    :options="typeFenetreOptions"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group :label="$t('nombre_fenetres') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].nombre_fenetres"
                    :placeholder="$t('nombre_fenetres')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('surface') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].surface_totale"
                    :placeholder="$t('surface')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('coefficient_transmission') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].coefficient_transmission"
                    :placeholder="$t('coefficient_transmission')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('facteur_solaire') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].facteur_solaire"
                    :placeholder="$t('facteur_solaire')"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>

              <!-- BAR-TH-127: Ventilation mécanique simple flux hygroréglable -->
              <div v-if="group.type_group === 'BAR-TH-127'">
                <b-form-group>
                  <template #label>
                    {{ $t("Type d'installation") }}
                  </template>
                  <b-form-radio-group
                    v-model="groupFormData[group.id].type_installation"
                    :options="installationTypeOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <div v-if="groupFormData[group.id].type_installation === 'Installation collective'">
                  <b-form-group>
                    <template #label>
                      {{ $t("Type de ventilation") }}
                    </template>
                    <b-form-radio-group
                      v-model="groupFormData[group.id].type_ventilation"
                      :options="ventilationTypeOptions"
                    >
                    </b-form-radio-group>
                  </b-form-group>
                  <b-form-group :label="$t('nombre_logements') + '*'">
                    <b-form-input
                      type="number"
                      min="0"
                      v-model="groupFormData[group.id].nombre_logements"
                      :placeholder="$t('nombre_logements')"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div v-if="groupFormData[group.id].type_installation === 'Installation individuelle'">
                  <b-form-group :label="$t('surface') + '*'">
                    <b-form-input
                      type="number"
                      min="0"
                      v-model="groupFormData[group.id].surface_habitable"
                      :placeholder="$t('surface')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group :label="$t('classe') + '*'">
                    <b-form-input
                      type="text"
                      v-model="groupFormData[group.id].classe_energetique"
                      :placeholder="$t('classe')"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <b-form-group :label="$t('Puissance') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    step="0.01"
                    v-model="groupFormData[group.id].puissance_electrique"
                    :placeholder="$t('Puissance')"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>

              <!-- BAR-TH-148: Chauffe-eau thermodynamique à accumulation -->
              <div v-if="group.type_group === 'BAR-TH-148'">
                <b-form-group :label="$t('type_installation')">
                  <b-form-select
                    v-model="groupFormData[group.id].type_installation"
                    :options="typeInstallationOptions"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group :label="$t('COP') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].cop"
                    :placeholder="$t('COP')"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>

              <!-- BAR-TH-143: Système solaire -->
              <div v-if="group.type_group === 'BAR-TH-143'">
                <b-form-group>
                  <template #label>
                    {{ $t("Type de certification") }}
                  </template>
                  <b-form-radio-group
                    v-model="groupFormData[group.id].certification_type"
                    :options="certificationTypeOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <div v-if="groupFormData[group.id].certification_type === 'certification'">
                  <b-form-group>
                    <template #label>
                      {{ $t("Type de norme") }}
                    </template>
                    <b-form-radio-group
                      v-model="groupFormData[group.id].norme_type"
                      :options="normeTypeOptions"
                    >
                    </b-form-radio-group>
                  </b-form-group>
                  <b-form-group :label="$t('NOM_CERTIF') + '*'">
                    <b-form-input
                      type="text"
                      v-model="groupFormData[group.id].certification"
                      :placeholder="$t('NOM_CERTIF')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group v-if="groupFormData[group.id].norme_type === 'autres'" :label="$t('NORM') + '*'">
                    <b-form-input
                      type="text"
                      v-model="groupFormData[group.id].norme"
                      :placeholder="$t('NORM')"
                    ></b-form-input>
                  </b-form-group>
                </div>
                <b-form-group :label="$t('FLUIDE') + '*'">
                  <b-form-input
                    type="text"
                    v-model="groupFormData[group.id].nature_fluide"
                    :placeholder="$t('FLUIDE')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Productivité')">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].productivite"
                    :placeholder="$t('Productivité')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Surface_chauffe')">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].surface_chaufe"
                    :placeholder="$t('Surface_chauffe')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Surface_hors_tout')">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].surface_hors_tout"
                    :placeholder="$t('Surface_hors_tout')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Capacite_stockage')">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].capacite_stockage"
                    :placeholder="$t('Capacite_stockage')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Classe_efficacite_energetique')">
                  <b-form-input
                    type="text"
                    v-model="groupFormData[group.id].classe_efficacite_energetique"
                    :placeholder="$t('Classe_efficacite_energetique')"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>

              <!-- BAR-TH-171: Pompe à chaleur de type air/eau -->
              <div v-if="group.type_group === 'BAR-TH-171'">
                <b-form-group :label="$t('Type_pompe') + '*'">
                  <b-form-select
                    v-model="groupFormData[group.id].denomination_temperature"
                    :options="pompeTypeOptions"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group :label="$t('Coeffcient_performance') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    step="0.01"
                    v-model="groupFormData[group.id].coefficient_performance"
                    :placeholder="$t('Coeffcient_performance')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Efficacité_calculer_selon_réglément') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].efficacite"
                    :placeholder="$t('Efficacité')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Surface_chauffe') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].surface_chauffee"
                    :placeholder="$t('Surface_chauffe')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Régulateur') + '*'">
                  <b-form-input
                    type="text"
                    v-model="groupFormData[group.id].regulateur_classe"
                    :placeholder="$t('Régulateur')"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>

              <!-- BAR-TH-129: Pompe à chaleur de type air/air -->
              <div v-if="group.type_group === 'BAR-TH-129'">
                <b-form-group :label="$t('Coeffcient_performance') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].coefficient_performance_saisonnier"
                    :placeholder="$t('Coeffcient_performance')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Puissance') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].puissance_nominale"
                    :placeholder="$t('Puissance')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('SURFACE') + '*'">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].surface_chauffee"
                    :placeholder="$t('SURFACE')"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>

              <!-- BAR-TH-137: Raccordement au réseau de chaleur -->
              <div v-if="group.type_group === 'BAR-TH-137'">
                <b-form-group>
                  <template #label>
                    {{ $t("Raccordé au réseau de chaleur") }}
                  </template>
                  <b-form-radio-group
                    v-model="groupFormData[group.id].deja_raccorder"
                    :options="raccordeOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <div v-if="groupFormData[group.id].deja_raccorder === true">
                  <b-form-group>
                    <template #label>
                      {{ $t("Raccordement") }}
                    </template>
                    <b-form-radio-group
                      v-model="groupFormData[group.id].existe_cetificat_economie"
                      :options="certificatOptions"
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <b-form-group v-if="getLogementType() === 'Maison individuelle'" :label="$t('Surface habitable (m²)')">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].surface_habitable"
                    placeholder="Surface en m²"
                  ></b-form-input>
                </b-form-group>
                <b-form-group v-if="getLogementType() === 'Collectif' || getLogementType() === 'Appartement'" :label="$t('nbr_appartements')">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].nbr_appartements"
                    :placeholder="$t('nbr_appartements')"
                  ></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('Nom du réseau')">
                  <b-form-input
                    type="text"
                    v-model="groupFormData[group.id].nom_reseau"
                    placeholder="Nom du réseau"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>

              <!-- BAR-TH-173: Système de régulation horaire -->
              <div v-if="group.type_group === 'BAR-TH-173'">
                <b-form-group :label="$t('Le type de système concerné')">
                  <b-form-select
                    v-model="groupFormData[group.id].concerne"
                    :options="concerneOptions"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group :label="$t('Classe de régulation')">
                  <b-form-select
                    v-model="groupFormData[group.id].class"
                    :options="classOptions"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group :label="$t('L\'ancien système est de classe C')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].ancient_system_class_c"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('les pièces sont équipées d\'émetteurs')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].pieces_equipees_emetteur"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('Dispositif central')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].comporte_appareil_central"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('dispose d\'une sonde de mesure')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].dispose_sonde_mesure"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('équipé d\'un dispositif de régulation')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].possede_dispositif_regulant"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('fonctionner localement au minimum')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].effectuer_local_minima"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('Dérogation locale possible')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].deroger_localement_consignes"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('Possibilité de fonctionnement en cas de perte de connexion')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].fonctionner_perte_connexion"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('le boîtier est équipé d\'émetteurs')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].logement_equipees_emetteur"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('Planchers/Plafonds chauffants')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].planchers_plafonds_chauffants"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('Remplacement du système existant')">
                  <b-form-radio-group
                    v-model="groupFormData[group.id].remlpacement"
                    :options="booleanOptions"
                  >
                  </b-form-radio-group>
                </b-form-group>
                <b-form-group :label="$t('Surface habitable (m²)')">
                  <b-form-input
                    type="number"
                    min="0"
                    v-model="groupFormData[group.id].surface_chauffe"
                    placeholder="Surface en m²"
                  ></b-form-input>
                </b-form-group>
                
                <b-form-group :label="$t('Données supplémentaires')">
                  <vue-editor
                    v-model="groupFormData[group.id].donnees_supplementaires"
                    :editor-toolbar="customToolbar"
                    class="mt-2"
                    :placeholder="$t('Ajouter des données supplémentaires')"
                  />
                </b-form-group>
              </div>
            </div>
            </div>
          </div>

 

          <b-form-group :label="$t('Attestation sur le bonheur - Bénéficiaire')">
            <vue-editor
              v-model="formData.attestationBeneficiaire"
              :editor-toolbar="customToolbar"
              class="mt-2"
              :placeholder="$t('Attestation sur le bonheur pour le bénéficiaire')"
            />
          </b-form-group>

          <b-form-group :label="$t('Attestation sur le bonheur - Professionnel')">
            <vue-editor
              v-model="formData.attestationProfessionnel"
              :editor-toolbar="customToolbar"
              class="mt-2"
              :placeholder="$t('Attestation sur le bonheur pour le professionnel')"
            />
          </b-form-group>
          <b-form-group :label="$t('Mentions finales')">
            <vue-editor
              v-model="formData.mentionsFinales"
              :editor-toolbar="customToolbar"
              class="mt-2"
              :placeholder="$t('Mentions finales')"
            />
          </b-form-group>

          <div class="form-actions">
            <b-button variant="danger" @click="goBack" class="mr-2">
              {{ $t("CANCEL") }}
            </b-button>
            <b-button
              variant="success"
              type="submit"
              :disabled="getdevisLoading || getAHLoading"
            >
              {{ $t("SAVE") }}
              <b-spinner
                v-if="getdevisLoading || getAHLoading"
                small
                variant="light"
                class="ml-2"
              ></b-spinner>
            </b-button>
          </div>
        </form>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import errorHandle from "../components/ui/errorHandle.vue";

export default {
  components: {
    errorHandle,
  },
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  data() {
    return {
      formData: {
        dateEngagement: null,
        factureId: null,
        datePrevuRealisation: null,
        mentionsFinales: "",
        attestationBeneficiaire: "",
        attestationProfessionnel: "",
      },
      selectedEntreprise: null,
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ header: 1 }, { header: 2 }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image"],
        ["clean"],
      ],
      selectedFactureGroups: [],
      factureDetails: null,
      groupFormData: {},
      activeTab: 0,
      // Options pour les formulaires
      typePoseOptions: [
        { value: "en combles perdu", text: "en combles perdu" },
        { value: "en rampant de toitures", text: "en rampant de toitures" },
      ],
      typeIsolantOptions: [
        { value: null, text: "Sélectionnez type", disabled: true },
        { value: "non reflechissant", text: "non reflechissant" },
        { value: "reflechissant", text: "reflechissant" },
      ],
      normesByType: {
        reflechissant: [{ value: "NF EN 16012+A1", text: "NF EN 16012+A1" }],
        "non reflechissant": [
          { value: "NF EN 12664", text: "NF EN 12664" },
          { value: "NF EN 12667", text: "NF EN 12667" },
          { value: "NF EN 12939", text: "NF EN 12939" },
        ],
      },
      protectionOptions: [
        { value: "A", text: "Pare-vapeur" },
        { value: "B", text: "Autre" },
      ],
      typeFenetreOptions: [
        { value: "fenêtre(s) de toiture", text: "fenêtre(s) de toiture" },
        { value: "double(s) fenêtre(s)", text: "double(s) fenêtre(s)" },
        { value: "porte(s)-fenêtre(s)", text: "porte(s)-fenêtre(s)" },
        { value: "autre(s) fenêtre(s)", text: "autre(s) fenêtre(s)" },
      ],
      installationTypeOptions: [
        { value: "Installation collective", text: "Installation collective" },
        { value: "Installation individuelle", text: "Installation individuelle" },
      ],
      ventilationTypeOptions: [
        { value: "C", text: "VMC simple flux hygroréglable" },
        { value: "D", text: "VMBP (ventilation mécanique basse pression) simple flux hygroréglable" },
      ],
      typeInstallationOptions: [
        { value: null, text: "Sélectionnez type", disabled: true },
        { value: "sur air extrait", text: "sur air extrait" },
        { value: "autres types d'installations", text: "autres types d'installations" },
      ],
      certificationTypeOptions: [
        { value: "certification", text: "certification" },
        { value: "caracteristiques", text: "capteurs possèdent caractéristiques performances" },
      ],
      normeTypeOptions: [
        { value: "fondée", text: "fondée sur les normes" },
        { value: "autres", text: "Autres normes" },
      ],
      pompeTypeOptions: [
        { value: "moyenne", text: "Température Moyenne" },
        { value: "haute", text: "Température Haute" },
        { value: "basse", text: "Température Basse" },
      ],
      raccordeOptions: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      certificatOptions: [
        { text: "Avec certificats énergie", value: true },
        { text: "Sans certificats énergie", value: false },
      ],
      concerneOptions: [
        { text: "système de chauffage ne disposant pas de régulation.", value: "système de chauffage ne disposant pas de régulation." },
        { text: "système de régulation existant.", value: "système de régulation existant." },
      ],
      classOptions: [
        { value: "A", text: "Classe A" },
        { value: "B", text: "Classe B" },
      ],
      booleanOptions: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
    };
  },
  validations() {
    return {
      formData: {
        dateEngagement: { required },
        factureId: { required },
        datePrevuRealisation: { required },
      },
    };
  },
  methods: {
    ...mapActions(["devis", "storeAH", "getonefacture", "all_entreprises"]),
    validateState(name) {
      const { $dirty, $error } = this.v$.formData[name];
      return $dirty ? !$error : null;
    },
    goBack() {
      this.$router.push("/AH");
    },
    async loadFactures() {
      try {
        const params = {
          page: 1,
          per_page: 100000000,
          type: "facture",
          brouillon: 0,
          ah: 0, // Filtrer les factures sans AH associé (0 = false)
        };
        
        // Si super admin, utiliser l'entreprise sélectionnée
        if (this.isSuperAdmin) {
          if (this.selectedEntreprise) {
            params.entreprise_id = this.selectedEntreprise;
          }
        } else {
          // Si ce n'est pas un super admin, utiliser automatiquement l'entreprise de l'utilisateur connecté
          if (this.getOnlineUser && this.getOnlineUser.entreprise) {
            if (typeof this.getOnlineUser.entreprise === 'object' && this.getOnlineUser.entreprise.id) {
              params.entreprise_id = this.getOnlineUser.entreprise.id;
            } else if (typeof this.getOnlineUser.entreprise === 'number' || typeof this.getOnlineUser.entreprise === 'string') {
              params.entreprise_id = this.getOnlineUser.entreprise;
            } else {
              params.entreprise = this.getOnlineUser.entreprise;
            }
          }
        }
        
        await this.devis(params);
      } catch (error) {
        console.error("Error loading factures:", error);
      }
    },
    async onEntrepriseChange() {
      // Réinitialiser la facture sélectionnée quand l'entreprise change
      this.formData.factureId = null;
      this.selectedFactureGroups = [];
      this.factureDetails = null;
      this.groupFormData = {};
      // Recharger les factures pour la nouvelle entreprise
      await this.loadFactures();
    },
    async onFactureChange(factureId) {
      if (!factureId) {
        this.selectedFactureGroups = [];
        this.factureDetails = null;
        this.groupFormData = {};
        return;
      }

      try {
        // Find the selected facture from the options
        const selectedOption = this.factureOptions.find(
          (opt) => opt.value === factureId
        );
        
        if (selectedOption && selectedOption.factureData) {
          const factureData = selectedOption.factureData;
          
          // Check multiple possible locations for groupeLigneDocument
          let groupes = factureData.groupeLigneDocument || 
                       factureData.devis?.groupeLigneDocument ||
                       factureData.data?.groupeLigneDocument;
          
          // If groupeLigneDocument is not available, fetch full facture details
          if (!groupes || groupes.length === 0) {
            // Try to get facture details using the document ID
            if (factureData.id) {
              try {
                const response = await this.getonefacture({ id: factureData.id });
                if (response && response.data) {
                  this.factureDetails = response.data;
                  groupes = response.data.groupeLigneDocument || 
                           response.data.devis?.groupeLigneDocument ||
                           response.data.data?.groupeLigneDocument;
                  this.selectedFactureGroups = groupes || [];
                }
              } catch (error) {
                console.error("Error fetching facture details:", error);
                // Fallback to empty groups
                this.selectedFactureGroups = [];
              }
            } else {
              this.selectedFactureGroups = [];
            }
          } else {
            // Use groupeLigneDocument from the facture data
            this.selectedFactureGroups = groupes;
            this.factureDetails = factureData;
          }

          // Initialize form data for each group
          this.initializeGroupFormData();
        }
      } catch (error) {
        console.error("Error loading facture groups:", error);
        this.selectedFactureGroups = [];
        this.groupFormData = {};
      }
    },
    initializeGroupFormData() {
      this.groupFormData = {};
      const devisData = this.factureDetails?.devis || this.factureDetails?.data?.devis || {};
      
      this.selectedFactureGroups.forEach((group) => {
        // Get the data source for this group type
        let groupData = null;
        switch (group.type_group) {
          case 'BAR-EN-101':
            groupData = devisData.isolation_combles_toiture;
            break;
          case 'BAR-EN-102':
            groupData = devisData.isolation_murs;
            break;
          case 'BAR-EN-103':
            groupData = devisData.isolation_plancher;
            break;
          case 'BAR-EN-104':
            groupData = devisData.fenetre_vitrage_complet;
            break;
          case 'BAR-TH-127':
            groupData = devisData.systeme_ventilation_mecanique_controlee;
            break;
          case 'BAR-TH-148':
            groupData = devisData.chauffe_eau_thermodynamiques;
            break;
          case 'BAR-TH-143':
            groupData = devisData.systeme_solaire;
            break;
          case 'BAR-TH-171':
            groupData = devisData.systeme_chauffage;
            break;
          case 'BAR-TH-129':
            groupData = devisData.pompe_chaleur_air_air;
            break;
          case 'BAR-TH-137':
            groupData = devisData.raccordement_batiment_residentiel_reseau_chaleur;
            break;
          case 'BAR-TH-173':
            groupData = devisData.systeme_regulation_horaire;
            break;
        }

        // Initialize base form data object
        const baseFormData = {
          // Common fields for isolation groups
          type_isolant: groupData?.type_isolant || null,
          norme: groupData?.norme || null,
          surface_isolant: groupData?.surface_isolant || "",
          Surface_isolant: groupData?.Surface_isolant || "",
          resistance_thermique: groupData?.resistance_thermique || "",
          epaisseur: groupData?.epaisseur || "",
          // Rich text editor for additional data
          donnees_supplementaires: groupData?.donnees_supplementaires || "",
        };

        // Add specific fields based on group type
        switch (group.type_group) {
          case 'BAR-EN-101':
            Object.assign(baseFormData, {
              necessite_pare_vapeur: groupData?.necessite_pare_vapeur ?? 0,
              type_pose: groupData?.type_pose || null,
            });
            break;
          case 'BAR-EN-103':
            Object.assign(baseFormData, {
              protection_type: groupData?.protection_type || "A",
            });
            break;
          case 'BAR-EN-104':
            Object.assign(baseFormData, {
              type_fenetre: groupData?.type_fenetre || null,
              nombre_fenetres: groupData?.nombre_fenetres || "",
              surface_totale: groupData?.surface_totale || "",
              coefficient_transmission: groupData?.coefficient_transmission || "",
              facteur_solaire: groupData?.facteur_solaire || "",
            });
            break;
          case 'BAR-TH-127':
            Object.assign(baseFormData, {
              type_installation: groupData?.type_installation || groupData?.type || "Installation collective",
              type_ventilation: groupData?.type_ventilation || groupData?.type || "C",
              nombre_logements: groupData?.nombre_logements || "",
              surface_habitable: groupData?.surface_habitable || "",
              classe_energetique: groupData?.classe_energetique || groupData?.classe || "",
              puissance_electrique: groupData?.puissance_electrique || "",
            });
            break;
          case 'BAR-TH-148':
            Object.assign(baseFormData, {
              type_installation: groupData?.type_installation || null,
              cop: groupData?.cop || "",
            });
            break;
          case 'BAR-TH-143':
            Object.assign(baseFormData, {
              certification_type: groupData?.certification_type || "certification",
              norme_type: groupData?.norme_type || "fondée",
              certification: groupData?.certification || "",
              nature_fluide: groupData?.nature_fluide || "",
              productivite: groupData?.productivite || "",
              surface_chaufe: groupData?.surface_chaufe || "",
              surface_hors_tout: groupData?.surface_hors_tout || "",
              capacite_stockage: groupData?.capacite_stockage || "",
              classe_efficacite_energetique: groupData?.classe_efficacite_energetique || "",
            });
            break;
          case 'BAR-TH-171':
            Object.assign(baseFormData, {
              denomination_temperature: groupData?.denomination_temperature || null,
              coefficient_performance: groupData?.coefficient_performance || "",
              efficacite: groupData?.efficacite || "",
              surface_chauffee: groupData?.surface_chauffee || "",
              regulateur_classe: groupData?.regulateur_classe || "",
            });
            break;
          case 'BAR-TH-129':
            Object.assign(baseFormData, {
              coefficient_performance_saisonnier: groupData?.coefficient_performance_saisonnier || "",
              puissance_nominale: groupData?.puissance_nominale || "",
              surface_chauffee: groupData?.surface_chauffee || "",
            });
            break;
          case 'BAR-TH-137':
            Object.assign(baseFormData, {
              deja_raccorder: groupData?.deja_raccorder ?? true,
              existe_cetificat_economie: groupData?.existe_cetificat_economie ?? false,
              nbr_appartements: groupData?.nbr_appartements || "",
              nom_reseau: groupData?.nom_reseau || "",
              surface_habitable: groupData?.surface_habitable || "",
            });
            break;
          case 'BAR-TH-173':
            Object.assign(baseFormData, {
              concerne: groupData?.concerne || "système de chauffage ne disposant pas de régulation.",
              class: groupData?.class || "A",
              ancient_system_class_c: groupData?.ancient_system_class_c ?? true,
              pieces_equipees_emetteur: groupData?.pieces_equipees_emetteur ?? true,
              comporte_appareil_central: groupData?.comporte_appareil_central ?? true,
              dispose_sonde_mesure: groupData?.dispose_sonde_mesure ?? true,
              possede_dispositif_regulant: groupData?.possede_dispositif_regulant ?? true,
              effectuer_local_minima: groupData?.effectuer_local_minima ?? true,
              deroger_localement_consignes: groupData?.deroger_localement_consignes ?? true,
              fonctionner_perte_connexion: groupData?.fonctionner_perte_connexion ?? true,
              logement_equipees_emetteur: groupData?.logement_equipees_emetteur ?? true,
              planchers_plafonds_chauffants: groupData?.planchers_plafonds_chauffants ?? true,
              remlpacement: groupData?.remlpacement ?? true,
              surface_chauffe: groupData?.surface_chauffe || "",
            });
            break;
        }

        this.groupFormData[group.id] = baseFormData;
      });
      
      // After initializing, trigger norme options update for groups with type_isolant
      this.selectedFactureGroups.forEach((group) => {
        if (this.groupFormData[group.id]?.type_isolant) {
          this.$nextTick(() => {
            this.updateNormeOptions(group.id);
          });
        }
      });
    },
    getNormeOptions(groupId) {
      const typeIsolant = this.groupFormData[groupId]?.type_isolant;
      return typeIsolant ? this.normesByType[typeIsolant] || [] : [];
    },
    updateNormeOptions(groupId) {
      // Reset norme when type_isolant changes
      if (this.groupFormData[groupId]) {
        this.groupFormData[groupId].norme = null;
      }
    },
    getLogementType() {
      // You may need to get this from facture details or store
      return this.factureDetails?.devis?.logement?.type || "Maison individuelle";
    },
    getGroupLabel(typeGroup) {
      const labelMap = {
        "BAR-EN-101": this.$t("Isolation de combles ou de toiture") || "Isolation de combles ou de toiture",
        "BAR-EN-102": this.$t("Isolation des murs") || "Isolation des murs",
        "BAR-EN-103": this.$t("Isolation d'un plancher") || "Isolation d'un plancher",
        "BAR-EN-104": this.$t("Fenêtre ou porte-fenêtre complète avec vitrage isolant") || "Fenêtre ou porte-fenêtre complète avec vitrage isolant",
        "BAR-TH-127": this.$t("Ventilation mécanique simple flux hygroréglable") || "Ventilation mécanique simple flux hygroréglable",
        "BAR-TH-148": this.$t("Chauffe-eau thermodynamique à accumulation") || "Chauffe-eau thermodynamique à accumulation",
        "BAR-TH-143": this.$t("Système solaire") || "Système solaire",
        "BAR-TH-171": this.$t("Pompe à chaleur de type air/eau") || "Pompe à chaleur de type air/eau",
        "BAR-TH-129": this.$t("Pompe à chaleur de type air/air") || "Pompe à chaleur de type air/air",
        "BAR-TH-137": this.$t("Raccordement au réseau de chaleur") || "Raccordement au réseau de chaleur",
        "BAR-TH-173": this.$t("Système de régulation horaire") || "Système de régulation horaire",
      };
      return labelMap[typeGroup] || typeGroup;
    },
    async handleSubmit() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        // Collect group form data with type_group for each group
        const groupsData = {};
        Object.keys(this.groupFormData).forEach((groupId) => {
          // Find the corresponding group to get its type_group
          const group = this.selectedFactureGroups.find(g => g.id == groupId);
          groupsData[groupId] = {
            ...this.groupFormData[groupId],
            type_group: group?.type_group || null, // Add type_group to each group
          };
        });

        /**
         * PAYLOAD COMPLET POUR LA CRÉATION D'UN AH (Attestation sur le Bonheur)
         * 
         * Structure du payload avec tous les cas possibles :
         */
        // Déterminer l'entreprise_id à utiliser
        let entrepriseId = null;
        if (this.isSuperAdmin) {
          // Si super admin, utiliser l'entreprise sélectionnée
          if (this.selectedEntreprise) {
            entrepriseId = this.selectedEntreprise;
          }
        } else {
          // Si ce n'est pas un super admin, utiliser automatiquement l'entreprise de l'utilisateur connecté
          if (this.getOnlineUser && this.getOnlineUser.entreprise) {
            if (typeof this.getOnlineUser.entreprise === 'object' && this.getOnlineUser.entreprise.id) {
              entrepriseId = this.getOnlineUser.entreprise.id;
            } else if (typeof this.getOnlineUser.entreprise === 'number' || typeof this.getOnlineUser.entreprise === 'string') {
              entrepriseId = this.getOnlineUser.entreprise;
            }
          }
        }

        const payload = {
          // Champs obligatoires de base
          facture_id: this.formData.factureId, // ID de la facture sélectionnée (obligatoire)
          engagement_date: this.formData.dateEngagement, // Date d'engagement (obligatoire)
          completion_date: this.formData.datePrevuRealisation, // Date prévue de réalisation (obligatoire)
          entreprise_id: entrepriseId, // ID de l'entreprise
          
          // Champs optionnels de texte riche
          mentions_finales: this.formData.mentionsFinales || null, // Mentions finales (HTML)
          attestation_beneficiaire: this.formData.attestationBeneficiaire || null, // Attestation bénéficiaire (HTML)
          attestation_professionnel: this.formData.attestationProfessionnel || null, // Attestation professionnel (HTML)
          
          // Données des groupes (un objet par groupe, indexé par l'ID du groupe)
          groups_data: groupsData, 
          /**
           * Structure de groups_data :
           * {
           *   [groupId]: {
           *     type_group: string, // Type du groupe (BAR-EN-101, BAR-EN-102, etc.) - OBLIGATOIRE
           *     // Champs communs à tous les groupes
           *     donnees_supplementaires: string, // HTML du rich text editor
           *     
           *     // Champs spécifiques selon le type de groupe (type_group) :
           *     
           *     // === BAR-EN-101: Isolation de combles ou de toiture ===
           *     necessite_pare_vapeur: 0 | 1,
           *     type_pose: string | null,
           *     type_isolant: string | null,
           *     norme: string | null,
           *     surface_isolant: string,
           *     resistance_thermique: string,
           *     epaisseur: string,
           *     
           *     // === BAR-EN-102: Isolation des murs ===
           *     type_isolant: string | null,
           *     norme: string | null,
           *     Surface_isolant: string,
           *     resistance_thermique: string,
           *     epaisseur: string,
           *     
           *     // === BAR-EN-103: Isolation d'un plancher ===
           *     protection_type: "A" | "B" | ...,
           *     type_isolant: string | null,
           *     norme: string | null,
           *     surface_isolant: string,
           *     resistance_thermique: string,
           *     epaisseur: string,
           *     
           *     // === BAR-EN-104: Fenêtre ou porte-fenêtre complète avec vitrage isolant ===
           *     type_fenetre: string | null,
           *     nombre_fenetres: string,
           *     surface_totale: string,
           *     coefficient_transmission: string,
           *     facteur_solaire: string,
           *     
           *     // === BAR-TH-127: Ventilation mécanique simple flux hygroréglable ===
           *     type_installation: "Installation collective" | "Installation individuelle",
           *     type_ventilation: "C" | ...,
           *     nombre_logements: string, // Si installation collective
           *     surface_habitable: string, // Si installation individuelle
           *     classe_energetique: string, // Si installation individuelle
           *     puissance_electrique: string,
           *     
           *     // === BAR-TH-148: Chauffe-eau thermodynamique à accumulation ===
           *     type_installation: string | null,
           *     cop: string,
           *     
           *     // === BAR-TH-143: Système solaire ===
           *     certification_type: "certification" | ...,
           *     norme_type: "fondée" | ...,
           *     certification: string,
           *     nature_fluide: string,
           *     productivite: string,
           *     surface_chaufe: string,
           *     surface_hors_tout: string,
           *     capacite_stockage: string,
           *     classe_efficacite_energetique: string,
           *     
           *     // === BAR-TH-171: Pompe à chaleur de type air/eau ===
           *     denomination_temperature: string | null,
           *     coefficient_performance: string,
           *     efficacite: string,
           *     surface_chauffee: string,
           *     regulateur_classe: string,
           *     
           *     // === BAR-TH-129: Pompe à chaleur de type air/air ===
           *     coefficient_performance_saisonnier: string,
           *     puissance_nominale: string,
           *     surface_chauffee: string,
           *     
           *     // === BAR-TH-137: Raccordement au réseau de chaleur ===
           *     deja_raccorder: true | false,
           *     existe_cetificat_economie: true | false,
           *     nbr_appartements: string,
           *     nom_reseau: string,
           *     surface_habitable: string,
           *     
           *     // === BAR-TH-173: Système de régulation horaire ===
           *     concerne: "système de chauffage ne disposant pas de régulation." | "système de régulation existant.",
           *     class: "A" | "B",
           *     ancient_system_class_c: true | false,
           *     pieces_equipees_emetteur: true | false,
           *     comporte_appareil_central: true | false,
           *     dispose_sonde_mesure: true | false,
           *     possede_dispositif_regulant: true | false,
           *     effectuer_local_minima: true | false,
           *     deroger_localement_consignes: true | false,
           *     fonctionner_perte_connexion: true | false,
           *     logement_equipees_emetteur: true | false,
           *     planchers_plafonds_chauffants: true | false,
           *     remlpacement: true | false,
           *     surface_chauffe: string,
           *   },
           *   // ... autres groupes
           * }
           */
        };

        // Log du payload complet pour debug (à retirer en production si nécessaire)
        console.log("Payload complet pour création AH:", JSON.stringify(payload, null, 2));

        await this.storeAH(payload);
        
        // Rediriger vers la liste après succès
        this.$router.push("/AH");
      } catch (error) {
        console.error("Error creating AH:", error);
        // Vous pouvez ajouter une notification d'erreur ici
        alert(error?.response?.data?.message || error?.message || "Une erreur est survenue lors de la création.");
      }
    },
  },
  computed: {
    ...mapGetters([
      "getAlldevis",
      "getdevisLoading",
      "getTabs",
      "getOnlineUser",
      "getAHLoading",
      "getAllentreprises",
      "getentrepriseLoading",
    ]),
    isSuperAdmin() {
      return this.getOnlineUser && this.getOnlineUser.role == "user.super-admin";
    },
    entrepriseOptions() {
      if (!this.getAllentreprises || !Array.isArray(this.getAllentreprises)) {
        return [];
      }
      return this.getAllentreprises.map((entreprise) => ({
        value: entreprise.id,
        text: entreprise.lib,
      }));
    },
    factureOptions() {
      if (!this.getAlldevis || !Array.isArray(this.getAlldevis)) {
        return [];
      }
      return this.getAlldevis.map((item) => {
        const devis = item.devis || {};
        // Utiliser numerofacture si disponible, sinon numerodevis
        const number = devis.numerofacture || devis.numerodevis || `#${item.id}`;
        const clientName = devis.client 
          ? `${devis.client.prenom || ""} ${devis.client.nom || ""}`.trim()
          : "";
        const entrepriseName = item.entreprise ? item.entreprise.lib : "";
        const displayText = clientName 
          ? `${number} - ${clientName}${entrepriseName ? ` (${entrepriseName})` : ""}`
          : `${number}${entrepriseName ? ` - ${entrepriseName}` : ""}`;
        return {
          // Utiliser l'ID du devis (item.devis.id) et non l'ID du document (item.id)
          // car l'API attend l'ID du devis pour les factures
          value: item.devis ? item.devis.id : item.id, // ID du devis
          text: displayText,
          factureData: item, // Stocker les données complètes pour l'affichage
        };
      });
    },
    selectedFactureInfo() {
      if (!this.formData.factureId) {
        return null;
      }
      const selectedOption = this.factureOptions.find(
        (opt) => opt.value === this.formData.factureId
      );
      if (!selectedOption || !selectedOption.factureData) {
        return null;
      }
      const facture = selectedOption.factureData;
      const devis = facture.devis || {};
      return {
        factureNumber: devis.numerofacture || devis.numerodevis || `#${facture.id}`,
        clientName: devis.client
          ? `${devis.client.prenom || ""} ${devis.client.nom || ""}`.trim()
          : null,
        entrepriseName: facture.entreprise ? facture.entreprise.lib : null,
      };
    },
  },
  async mounted() {
    // Charger les entreprises si super admin
    if (this.isSuperAdmin) {
      await this.all_entreprises({
        page: 1,
        per_page: 1000,
      });
    }
    // Charger les factures
    await this.loadFactures();
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 20px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #dee2e6;
}

.button-danger-style {
  background-color: #dc3545;
  border-color: #dc3545;
  color: #fff;
}

.button-danger-style:hover {
  background-color: #c82333;
  border-color: #bd2130;
}

.facture-info {
  .info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    padding: 4px 0;
    border-bottom: 1px solid #dee2e6;

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }

    strong {
      color: #28367a;
      margin-right: 10px;
    }

    span {
      color: #515151;
    }
  }
}

.conditional-forms {
  margin-top: 20px;
}

.form-group-section {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 20px;
  background-color: #f8f9fa;
}

.group-header {
  h4 {
    color: #24316d;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 2px solid #24316d;
  }
}
</style>

